module.exports = __webpack_public_path__ + "img/bell-outline.2d43d104.svg";